<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ data.cancelText }}</button>
  <button mat-button color="warn" [mat-dialog-close]="true">{{ data.confirmText }}</button>
</mat-dialog-actions>
